import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "../api"
import { SuiteModel } from "../api/suite.api"
import { GLOBAL_CONSTANTS } from "../constants/constants"

export interface SuitesListState {
    suites: SuiteModel
    loading: boolean
    error?: string
}

const initialState: SuitesListState = {
    suites: {
        total: 0,
        suites: [],
        page: GLOBAL_CONSTANTS.PAGE,
        page_size: GLOBAL_CONSTANTS.PAGE_SIZE
    },
    loading: false
}
export interface paginationData {
    page?: number
    pageSize?: number
    search?: string
    warehouse?: string
    status?: string
}
export const loadSuites = createAsyncThunk("suites/list", async (data: paginationData, thunkAPI) => {
    try {
        const response = await api.suite.suitesList(data)
        return response
    } catch (error: any) {
        console.log(error)
        return error.message
    }
})

export const suitesSlice = createSlice({
    name: "suites",
    initialState,

    reducers: {
        clearError: (state: SuitesListState) => {
            state.error = undefined
        }
    },

    extraReducers: {
        [loadSuites.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadSuites.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [loadSuites.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.suites = action.payload?.data?.payload || []
        }
    }
})

export const { clearError } = suitesSlice.actions

export default suitesSlice.reducer
